import { memo, useCallback, useState } from "react";
import PropTypes from "prop-types";
import Hamburger from "app/pages/Header/Hamburger/Hamburger";
import LogoBrandContainer from "app/pages/.shared/LogoBrand/LogoBrandContainer";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { BRANDS } from "app/constants";
import { brandPropTypes } from "app/utils/propTypes";
import "./ProductStickyHeader.scss";
import HamburgerAccount from "app/pages/.shared/HamburgerAccount/HamburgerAccount";
import SidePanel from "app/pages/.shared/SidePanel/SidePanel";
import { AsideMenuAccountContainer } from "app/pages/.shared/AsideMenu/AsideMenuAccountContainer";

const ProductStickyHeader = ({
	showHamburger,
	toggleAsideMenu,
	brand,
	isAsideMenuOpened,
	fallbackRedirectUrl,
}) => {
	const isBrandXX = brand === BRANDS.XX;
	const isBrandTO = brand === BRANDS.TO;
	const [isSideMenuOpened, toggleSideMenu] = useState(false);

	const openSideMenu = useCallback(() => {
		toggleSideMenu(!isSideMenuOpened);
	}, [isSideMenuOpened]);

	const closeSideMenu = useCallback(() => {
		toggleSideMenu(false);
	}, []);

	return isBrandTO ? (
		<header className="product-sticky-header product-sticky-header--to">
			<div className="product-sticky-header__brand">
				<div className="product-sticky-header__logo">
					{isBrandXX ? (
						<LogoBrandContainer />
					) : (
						<RelativeLink to={{ pathname: fallbackRedirectUrl }}>
							<LogoBrandContainer
								isWhite={brand === BRANDS.EK || brand === BRANDS.HP}
							/>
						</RelativeLink>
					)}
				</div>
			</div>
			<div className="product-sticky-header__hamburger">
				<div className="header__hamburger">
					<HamburgerAccount onToogle={openSideMenu} />
					<SidePanel
						isOpen={isSideMenuOpened}
						direction={"rtl"}
						onClose={closeSideMenu}
						disableBlockViewPortScroll
					>
						<AsideMenuAccountContainer onClose={closeSideMenu} />
					</SidePanel>
				</div>
			</div>
		</header>
	) : (
		<header className="product-sticky-header">
			<div className="product-sticky-header__hamburger">
				{showHamburger && (
					<Hamburger onToogle={toggleAsideMenu} isActive={isAsideMenuOpened} />
				)}
			</div>
			<div className="product-sticky-header__brand">
				<div className="product-sticky-header__logo">
					{isBrandXX ? (
						<LogoBrandContainer />
					) : (
						<RelativeLink to={{ pathname: fallbackRedirectUrl }}>
							<LogoBrandContainer
								isWhite={brand === BRANDS.EK || brand === BRANDS.HP}
							/>
						</RelativeLink>
					)}
				</div>
			</div>
		</header>
	);
};

ProductStickyHeader.propTypes = {
	toggleAsideMenu: PropTypes.func,
	isAsideMenuOpened: PropTypes.bool,
	showHamburger: PropTypes.bool,
	brand: brandPropTypes,
	fallbackRedirectUrl: PropTypes.string,
};

export default memo(ProductStickyHeader);
